// Telefone brasileiro: banco sem mascara; exibicao com DDD e hifen.
export function telefoneDigitos(valor) {
  let n=String(valor||'').replace(/\D/g,'');
  if((n.length===12||n.length===13)&&n.startsWith('55'))n=n.slice(2);
  return n.slice(0,11);
}
export function formatarTelefone(valor) {
  const n=telefoneDigitos(valor);
  if(!n)return '';
  if(n.length<3)return '('+n;
  const local=n.slice(2),corte=local.length>8?5:4;
  return '('+n.slice(0,2)+') '+local.slice(0,corte)+(local.length>corte?'-'+local.slice(corte):'');
}
